
import React from "react";
import { useNavigate } from "react-router-dom";

import LessonShell from "./LessonShell";

export default function LevelVideoTemplate({
  /*
   * Only summary videos should currently show a title.
   */
  title = "",
  showHeading = false,

  /*
   * Kept for compatibility with RenderSanityStep.
   * This template no longer renders a video type label.
   */
  videoType = "video",

  videoUrl = "",

  nextTo,
  backTo,
  nextLabel = "NEXT",
  backLabel = "Back",

  onNext,
  onBack,

  progressStep = 1,
  progressTotal = 1,
}) {
  const navigate = useNavigate();

  const canGoNext = !!onNext || !!nextTo;

  const handleBack = () => {
    if (onBack) {
      onBack();
      return;
    }

    if (backTo) {
      navigate(backTo);
      return;
    }

    navigate(-1);
  };

  const handleNext = () => {
    if (onNext) {
      onNext();
      return;
    }

    if (nextTo) {
      navigate(nextTo);
    }
  };

  return (
    <LessonShell
      progressStep={progressStep}
      progressTotal={progressTotal}
      showBack
      backLabel={backLabel}
      onBack={handleBack}
      showNext
      nextLabel={nextLabel}
      onNext={handleNext}
      nextDisabled={!canGoNext}
      contentClassName="pt-4 pb-8"
    >
      <div
        style={{
          width: "100%",
          maxWidth: "800px",
          margin: "0 auto",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {showHeading && !!title && (
          <h1
            style={{
              width: "100%",
              margin: "0 0 18px",
              textAlign: "center",
              fontSize: "24px",
              lineHeight: 1.15,
              fontWeight: 800,
              letterSpacing: "-0.03em",
              color: "#111111",
            }}
          >
            {title}
          </h1>
        )}

        <section
          style={{
            width: "100%",
            marginTop: showHeading && title ? "0" : "8px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              width: "100%",
              maxWidth: "800px",
              aspectRatio: "1 / 1",
              overflow: "hidden",
              borderRadius: "28px",
              backgroundColor: "#000000",
              boxShadow: "0 10px 26px rgba(0, 0, 0, 0.12)",
            }}
          >
            {videoUrl ? (
              <video
                src={videoUrl}
                controls
                playsInline
                preload="metadata"
                style={{
                  display: "block",
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                  backgroundColor: "#000000",
                }}
              />
            ) : (
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "24px",
                  textAlign: "center",
                }}
              >
                <p
                  style={{
                    color: "rgba(255, 255, 255, 0.7)",
                    fontSize: "14px",
                    fontWeight: 700,
                  }}
                >
                  Video not available yet.
                </p>
              </div>
            )}
          </div>
        </section>

        <div
          style={{
            width: "100%",
            marginTop: "18px",
            borderRadius: "16px",
            backgroundColor: "#F7F7F7",
            padding: "12px 16px",
          }}
        >
          <p
            style={{
              margin: 0,
              textAlign: "center",
              fontSize: "12px",
              lineHeight: 1.45,
              fontWeight: 500,
              color: "#777777",
            }}
          >
            Watch the video, then tap NEXT to continue.
          </p>
        </div>
      </div>
    </LessonShell>
  );
}
